import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { APIConstant } from '@/constant/APIConstant';
import { get } from 'jquery';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient) { }
  getAllOwner(
    page: number = 1,
    limit: number = 10,
    sort_by: string = 'updated_at',
    sort_label: 'asc' | 'desc' = 'desc',
    search: string = '',
    is_flight_school: string | '' = ''
  ) {
    let params: any = {
      page,
      limit,
      sort_by,
      sort_label
    };

    if (search) params.search = search;
    if (is_flight_school !== '') params.is_flight_school = is_flight_school;

    return this.http.get(`${environment.baseUrlAerolounge}${APIConstant.owner.getOwnerList}`, {
      params
    });
  }



  getAllPilot(
    page: number = 1,
    limit: number = 10,
    search: string = '',
    sort_by: string = 'updated_at',
    sort_label: string = 'desc'
  ) {
    const url = `${environment.baseUrlAerolounge}${APIConstant.pilot.getPilotList}`;
    const params = {
      page,
      limit,
      search,
      sort_by,
      sort_label
    };

    return this.http.get(url, { params });
  }


  approveRejectUser(payload: any) {
    return this.http.put(`${environment.baseUrlAerolounge}/admin/v1/users/approve-reject-user`, payload);
  }
  getLegalCompliance(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/pilot/get-legal-compliance/${user_id}`);
  }
  getFlightExpOverview(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/pilot/get-flight-exp-overview/${user_id}`);
  }
  getPilotDocuments(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/pilot/get-pilot-documents/${user_id}`);
  }
  getPilotFlyingGoals(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/pilot/get-pilot-flying-goals/${user_id}`);
  }
  getPilotEmergencyContact(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/pilot/get-pilot-emergency-contacts/${user_id}`);
  }
  getUserPlatformPref(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/pilot/get-user-platform-prefs/${user_id}`);
  }
  getAllOwnerAircraft(
    page: number = 1,
    limit: number = 10,
    sort_by: string = 'updated_at',
    sort_label: string = 'desc',
    search: string = '',
    aircraft_review_status: string = ''
  ) {
    return this.http.get(
      `${environment.baseUrlAerolounge}/admin/v1/owner/get-all-aircrafts?page=${page}&page_size=${limit}&sort_by=${sort_by}&sort_label=${sort_label}&search=${search}&aircraft_review_status=${aircraft_review_status}`
    );
  }


  getAirSpecifications(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/owner/get-aircraft-specifications/${user_id}`);
  }
  getArowDoc(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/owner/get-aircraft-arow-docs/${user_id}`);
  }
  getMainDocuments(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/owner/get-aircraft-maintenance-docs/${user_id}`);
  }
  getADCompliences(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/owner/get-aircraft-ad-compliance/${user_id}`);
  }
  getInsuVerification(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/owner/get-aircraft-insurance-varification/${user_id}`);
  }
  getMainTracking(user_id) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/owner/get-aircraft-maintenance-tracking/${user_id}`);
  }
  approveRejectAircraft(payload: any) {
    return this.http.put(`${environment.baseUrlAerolounge}/admin/v1/owner/approve-reject-aircraft`, payload);
  }
  getAllConfigurations(page: number = 1, limit: number = 10, category: any = '') {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/global-variables/?page=${page}&per_page=${limit}&category=${category}`);
  }
  toggleStatusGlobal(var_id: any) {
    return this.http.patch(`${environment.baseUrlAerolounge}/admin/v1/global-variables/${var_id}/toggle-status`, {});
  }
  updateConfiguration(payload: any) {
    return this.http.put(`${environment.baseUrlAerolounge}/admin/v1/global-variables/${payload.id}`, payload);
  }
  getUserActivityLogs(
    userId: number,
    userType: string,
    page: number = 1,
    pageSize: number = 10,
    categories: string[] = [],
    startDate?: string,
    endDate?: string,
    searchText?: string
  ) {
    let params = new HttpParams()
      .set('user_id', userId.toString())
      .set('user_type', userType)
      .set('page', page.toString())
      .set('page_size', pageSize.toString());

    // add categories (multiple)
    categories.forEach(cat => {
      params = params.append('category', cat);
    });

    // add optional params only if provided
    if (startDate) {
      params = params.set('start_date', startDate);
    }
    if (endDate) {
      params = params.set('end_date', endDate);
    }
    if (searchText) {
      params = params.set('search_text', searchText);
    }



    console.log("params ::>>", params);

    return this.http.get(
      `${environment.baseUrlAerolounge}/admin/v1/user-activity-logs/`,
      { params }
    );
  }


  getUserActivityStats(
    userId: number,
    startDate?: string,
    endDate?: string
  ) {
    let params = new HttpParams()
      .set('user_id', userId.toString())

    if (startDate) {
      params = params.set('start_date', startDate);
    }
    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(
      `${environment.baseUrlAerolounge}/admin/v1/user-activity-logs/pilot-activity-statistics`,
      { params }
    );
  }

  getOwnerActivityStats(
    userId: number,
    startDate?: string,
    endDate?: string
  ) {
    let params = new HttpParams()
      .set('user_id', userId.toString())

    if (startDate) {
      params = params.set('start_date', startDate);
    }
    if (endDate) {
      params = params.set('end_date', endDate);
    }

    return this.http.get(
      `${environment.baseUrlAerolounge}/admin/v1/user-activity-logs/owner-activity-statistics`,
      { params }
    );
  }

  toggleStatusBanned(payload: any) {
    return this.http.put(`${environment.baseUrlAerolounge}/admin/v1/users/toggle-ban-user`, payload);
  }
  getAllInqueries(
    page: number = 1,
    page_size: number = 10,
    search: string = '',
    inquiry_type: string = '',
    sort_by: string = 'created_at',      // 👈 Added
    sort_label: string = 'desc',         // 👈 Defaulted to 'desc'
    user_type: string = ''
  ) {
    const params: any = {
      page,
      page_size,
    };

    if (search) params.search = search;
    if (inquiry_type) params.inquiry_type = inquiry_type;
    if (sort_by) params.sort_by = sort_by;           // 👈 Added
    if (sort_label) params.sort_label = sort_label;  // ✅ Existing
    if (user_type) params.user_type = user_type;

    return this.http.get(
      `${environment.baseUrlAerolounge}/admin/v1/support/get-inquiries`,
      { params }
    );
  }

  getStatistics() {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/dashboard/statistics`);
  }
  getPilotTrend() {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/dashboard/pilot-user-trends`);
  }
  getOwnerTrend() {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/dashboard/owner-user-trends`);
  }

  getSupportTicketConversation(support_ticket_id: number, user_type: string) {
    return this.http.get(`${environment.baseUrlAerolounge}/admin/v1/support/get-support-ticket-conversation`, {
      params: { support_ticket_id: support_ticket_id, user_type: user_type }
    });
  }

  replyToTicket(payload: any) {
    return this.http.post(`${environment.baseUrlAerolounge}/admin/v1/support/reply-support-ticket`, payload);
  }

  markSupportTicketClosed(ticketId: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    const payload = new URLSearchParams();
    payload.set('support_ticket_id', ticketId.toString());

    return this.http.put(`${environment.baseUrlAerolounge}/admin/v1/support/mark-support-ticket-closed`, payload, { headers });
  }






}